import PropTypes from 'prop-types';

const RowDetail = (props) => {
  const { label, value, valueExtraClasses, icon } = props;

  return (
    <div className="total__details">
      <div className="total__details__label">
        {typeof icon === 'string' ? (
          <div className={`total__details__icon ${icon}`} />
        ) : (
          <span className="total__details__icon">{icon}</span>
        )}
        {label}
      </div>
      <div
        className={['total__details__value', ...(valueExtraClasses || [])].join(
          ' '
        )}
      >
        {value}
      </div>
    </div>
  );
};

RowDetail.defaultProps = {
  label: '',
  value: '',
  valueExtraClasses: [],
  icon: '',
};

RowDetail.propTypes = {
  label: PropTypes.string,
  value: PropTypes.node,
  valueExtraClasses: PropTypes.arrayOf(PropTypes.string),
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

export default RowDetail;
